import { Component, OnInit } from '@angular/core';
import { ApiRequestService } from './../../../../BaseFramework/core/http/api-request.service';

@Component({
  selector: 'app-org-hierarchy',
  templateUrl: './org-hierarchy.component.html',
  styleUrls: ['./org-hierarchy.component.scss']
})
export class OrgHierarchyComponent implements OnInit {

  constructor(
      private apiRequest: ApiRequestService,
  ) { }

  private currentUser: any;
  private currentUserReportees:any;

  ngOnInit() {
    this.updateData('whole');

    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    
    this.currentUser.id = 127;
      
    /*agentDO.userId */

    this.apiRequest.get("agent/fetchById/"+this.currentUser.id).subscribe(data=>{this.currentUser = data;console.log(data)});
   
  }
  

  selectedHier:string = "whole";
  topEmployee:any;
  
  updateData( what:string) {
    if("whole"==what) {
      this.topEmployee = {
        name: 'Yugi Martin',
        designation: 'CEO',
        img: "https://randomuser.me/api/portraits/men/40.jpg",
        subordinates: [
          {
            name: 'Matthew Wikes',
            designation: 'Regional Sales Director',
            img: "https://randomuser.me/api/portraits/men/41.jpg",
            subordinates: [
              {
                name: 'Tina Landry',
                designation: 'Agent',
                img: "https://randomuser.me/api/portraits/women/40.jpg",
                subordinates: []
              }

            ]
          },
          {
            name: 'Patricia Lyons',
            designation: 'Regional Sales Director',
            img: "https://randomuser.me/api/portraits/women/10.jpg",
            subordinates: [
              {
                name: 'Dylan Wilson',
                designation: 'Agent',
                img: "https://randomuser.me/api/portraits/men/31.jpg",
                subordinates: []
              },
              {
                name: 'Deb Curtis',
                designation: 'Agent',
                img: "https://randomuser.me/api/portraits/men/23.jpg",
                subordinates: []
              },
              {
                name: 'Wilson Davis',
                designation: 'Agent',
                img: "https://randomuser.me/api/portraits/men/55.jpg",
                subordinates: []
              },
            ]
          },
          {
            name: 'Larry Phung',
            designation: 'Regional Sales Director',
            img: "https://randomuser.me/api/portraits/men/44.jpg",
            subordinates: []
          }
        ]
      };
    }
    else {
      this.topEmployee = {
        name: 'Yugi Martin',
        designation: 'CEO',
        img: "https://randomuser.me/api/portraits/men/40.jpg",
        subordinates: [
          {
            name: 'Patricia Lyons (YOU)',
            designation: 'Regional Sales Director',
            img: "https://randomuser.me/api/portraits/women/10.jpg",
            subordinates: [
              {
                name: 'Dylan Wilson',
                designation: 'Agent',
                img: "https://randomuser.me/api/portraits/men/31.jpg",
                subordinates: []
              },
              {
                name: 'Deb Curtis',
                designation: 'Agent',
                img: "https://randomuser.me/api/portraits/men/23.jpg",
                subordinates: []
              },
              {
                name: 'Wilson Davis',
                designation: 'Agent',
                img: "https://randomuser.me/api/portraits/men/54.jpg",
                subordinates: []
              },
            ]
          },
        ]
      };
    }
  }


}
